(function() {
  'use strict';
  
  angular
    .module('app.result')
    .controller('ResultController', ResultController);
    
  ResultController.$inject = [
    '$log', 
    '$q',
    '$scope',
    '$state', 
    '$stateParams',
    '$mdDialog',
    'auth',
    'plugins',
    'PLUGIN_ACTIONS',
    'resultService'
  ];
  
  function ResultController(
      $log, 
      $q,
      $scope, 
      $state, 
      $stateParams,
      $mdDialog,
      auth, 
      plugins,
      PLUGIN_ACTIONS, 
      resultService) {
    $log = $log.getInstance('ResultController');
    
    var vm = this;
    
    vm.archiveMode = false;
    vm.close = close;
    vm.hideResult = hideResult;
    vm.goNextPollInGroup = goNextPollInGroup;
    vm.goPreviousPollInGroup = goPreviousPollInGroup;
    vm.isFirstPollInGroup = isFirstPollInGroup;
    vm.isLastPollInGroup = isLastPollInGroup;
    vm.isOwner = false;
    vm.isResultShown = isResultShown;
    vm.poll = null;
    vm.result = null;
    vm.resetPoll = resetPoll;
    vm.resultViewTemplate = resultViewTemplate;
    vm.resume = resume;
    vm.showResult = showResult;
    vm.toast = null;
    vm.toggleActive = toggleActive;
    vm.toggleShown = toggleShown;
    vm.viewResult = viewResult;
    
    var closeState = null
    var closeStateParams = null;
    
    activate();
    
    function activate() {
      _storeCloseState();    
      auth.isAuthenticated().then(function(user) {
        var resultId = $stateParams.resultId;
        resultService.subscribe(resultId)
          .then(function(result) {
            $log.debug('result = ', result);
            vm.poll = result.poll;
            vm.result = result;
            vm.isOwner = _.contains(result.pollCollection.owners, user._id);
            vm.archiveMode = $stateParams.mode === 'archive';
            resultService.onResultActivate($scope, onResultActivate);
            resultService.onResultDeactivate($scope, onResultDeactivate);
            return resultService.getResultHistory(result.poll._id);
          })
          .then(function(pastResults) {
            vm.pastResults = pastResults
          }).catch(function(err) {
            $log.error(err);
            if (err.code && err.code === 404)
              $mdDialog.show(
                $mdDialog.alert()
                  .title('Not Found')
                  .content('The result does not exist')
                  .ok('Go Back')
              )
              // temp fix for https://github.com/angular/material/issues/10369
              .catch(angular.noop);
          });
      });
    }
    
    function close() {
      closeState = closeState || 'shell.myPolls';
      $state.go(closeState, closeStateParams);
    }
    
    function deactivate(result) {
      if (!result.active)
        return;
      resultService.deactivate(result._id).then(function() {
        result.active = false;
      });
    }
    
    function discardResult() {
      var confirm = $mdDialog.confirm()
        .title('Discard result')
        .htmlContent('No responses were received. This result will be discarded.')
        .ok('Okay')
        .cancel('Cancel');
      return $mdDialog.show(confirm)
        .then(function() {
          vm.result.discarded = new Date();
          return resultService.update(vm.result, 'discarded');
        })
        // temp fix for https://github.com/angular/material/issues/10369
        .catch(angular.noop);
    }

    function hideResult() {
      $state.go('result.hidden');
    }

    function isResultShown() {
      return $state.current.name === 'result.shown';
    }

    function goNextPollInGroup() {
      var polls = _.filter(vm.result.group.polls, function(poll){
        return !angular.isString(poll.deleted);
      });
      var pollIndex = _.findIndex(polls, function(poll){
        return poll._id === vm.result.poll._id;
      })
      var nextPoll = polls[pollIndex + 1]
      if (!nextPoll)
        return $q.reject('Already at the last poll in the group');
      return viewLastResultForPoll(nextPoll);
    }

    function goPreviousPollInGroup() {
      var polls = _.filter(vm.result.group.polls, function(poll){
        return !angular.isString(poll.deleted);
      });
      var pollIndex = _.findIndex(polls, function(poll){
        return poll._id === vm.result.poll._id;
      })
      var lastPoll = polls[pollIndex - 1];
      if (!lastPoll)
        return $q.reject('Already at the first poll in the group');
      return viewLastResultForPoll(lastPoll);
    }

    function isFirstPollInGroup() {
      var polls = _.filter(vm.result.group.polls, function(poll){
        return !angular.isString(poll.deleted);
      });
      var pollIndex = _.findIndex(polls, function(poll){
        return poll._id === vm.result.poll._id;
      })
      return (pollIndex === 0);
    }

    function isLastPollInGroup() {
      var polls = _.filter(vm.result.group.polls, function(poll){
        return !angular.isString(poll.deleted);
      });
      var pollIndex = _.findIndex(polls, function(poll){
        return poll._id === vm.result.poll._id;
      })
      return (pollIndex === (polls.length -1));
    }
    
    function onResultActivate(event, result) {
      if (result._id === vm.result._id)
        vm.result.active = true;
    }
    
    function onResultDeactivate(event, result) {
      if (result._id === vm.result._id)
        vm.result.active = false;
    }
    
    function resetPoll() {
      var promise = (vm.result.responses.length === 0)
        ? discardResult()
        : saveResult();
      promise
        .then(function() {
          return resultService.createResult(vm.poll._id);
        })
        .then(viewResult);
    }
    
    function resultViewTemplate(poll) {
      return 'plugins/' + result.type + '/' + result.type + '.result.edit.html';
    }
    
    function resume(result) {
      if (result.active)
        return;
      resultService.resume(result._id).then(function(resumedResult) {
        result.activations = resumedResult.activations;
        result.active = true;
      });
    }
    
    function saveResult() {
      if (vm.result.label)
        return $q.resolve();
      var prompt = $mdDialog.prompt()
        .title('Save result')
        .htmlContent('Enter a label for this result to help you find it in future.<br/>The date will be automatically added for you.')
        .placeholder('Label eg. Week 1 Lecture 1')
        .ariaLabel('Result label')
        .ok('Save')
        .cancel('Cancel');
      return $mdDialog.show(prompt).then(function(label) {
        vm.result.label = label;
        return resultService.update(vm.result, 'label');
      })
      // temp fix for https://github.com/angular/material/issues/10369
      .catch(angular.noop);
    }

    function showResult() {
      $state.go('result.shown');
    }
    
    function toggleActive() {
      vm.result.active
        ? deactivate(vm.result)
        : resume(vm.result);
    }

    function toggleShown() {
      isResultShown()
        ? hideResult()
        : showResult();
    }

      function viewLastResultForPoll(poll) {
      return resultService.getLastResult(poll)
        .then(viewResult)
        .catch(function(err) {
          if (err.code && err.code === 404)
            return resultService.createResult(poll).then(viewResult);
          return $q.reject(err);
        });
    }
    
    function viewResult(result) {
      $state.go($state.current, { 
        resultId: result._id,
        closeState: closeState,
        closeStateParams: closeStateParams
      });
    }
    
    $scope.$on('$destroy', function() {
      if (vm.isOwner && vm.result.active)
        resultService.deactivate(vm.result._id);
    });
    
    
    function _storeCloseState() {
      // This will be the state that the user is taken to when the result is closed
      if ($stateParams.closeState) {
        closeState = $stateParams.closeState;
        closeStateParams = $stateParams.closeStateParams;
      }
      else if ($scope.previousState) {
        closeState = $scope.previousState.name;
        closeStateParams = $scope.previousStateParams;
      }
      else {
        closeState = undefined;
        closeStateParams = undefined;
      }
      // // Hack to prevent toggling between result.shown and result.hidden
      // // from reloading the parent result state.
      // if (angular.isObject(closeStateParams))
      //   closeStateParams = JSON.stringify(closeStateParams);
    }
    
  }
  
})();